/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'nextOne': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M605.2 536.4L259.5 870.7c-22.5 21.3-21.3 54.8 2.7 74.8s61.6 18.9 84.1-2.4l417.1-395.4c21.5-20.4 21.5-52.1 0-72.4L346.3 79.9c-11.7-11.1-27.5-16.7-43.4-16.7-14.6 0-29.2 4.8-40.7 14.3-24 20-25.2 53.5-2.7 74.8l345.7 334.3v49.8z" _fill="#141414"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/nextOne.js